var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"flex xs12 md12"},[_c('va-card',{attrs:{"title":_vm.$t('chat.title')}},[_c('chat',{model:{value:(_vm.chatMessages),callback:function ($$v) {_vm.chatMessages=$$v},expression:"chatMessages"}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }